import camilaPhoto from "@/assets/team-camila.jpg";
import luisaPhoto from "@/assets/team-luisa.jpg";
import marceloPhoto from "@/assets/team-marcelo.jpg";
import isabelaPhoto from "@/assets/team-isabela.jpg";

export type TeamMember = {
  name: string;
  role: string;
  bio: string;
  photo: string;
  initials: string;
  accent: string;
};

export const TEAM: TeamMember[] = [
  {
    name: "Camila Ribeiro",
    role: "Editora-chefe",
    bio: "Jornalista com 15 anos de redação. Lidera a pauta diária da Gazeta Regional Online, coordena a equipe de reportagem e revisa cada matéria antes da publicação.",
    initials: "CR",
    accent: "#FBBF24",
    photo: camilaPhoto,
  },
  {
    name: "Luísa Fontes",
    role: "Repórter — Notícias e Atualidades",
    bio: "Cobre acontecimentos do dia a dia, política, economia e comportamento. Apura fontes, checa dados e escreve matérias factuais de leitura rápida.",
    initials: "LF",
    accent: "#111111",
    photo: luisaPhoto,
  },
  {
    name: "Marcelo Andrade",
    role: "Editor — Reviews e Guias de Compra",
    bio: "Assina os testes de produtos e serviços da Gazeta. Compara preços, mede desempenho e escreve rankings e reviews com veredito honesto.",
    initials: "MA",
    accent: "#4B5563",
    photo: marceloPhoto,
  },
  {
    name: "Isabela Prado",
    role: "Repórter — Tutoriais e Passo a Passo",
    bio: "Produz os conteúdos faça-você-mesmo, tira-dúvidas e guias práticos. Traduz temas técnicos em passos simples que qualquer leitor consegue seguir.",
    initials: "IP",
    accent: "#FBBF24",
    photo: isabelaPhoto,
  },
];
